<form #commissionAdd="ngForm" >
    <div class="row">
        <div class="col-lg-12">
          <div class="card border-0 shadow-none text-center">
            <div class="card-body">
              <h4 class="text-left">Exchange Rate Configuration</h4>
              <hr class="mt-2">
              <div class="row d-flex">
                <div class="form-group col-md-3 ">
                    <label class="col-form-label">Currency Name</label>
                    <input type="text" id="productName" readonly value="{{selectedCurrencyName}}"  class="form-control">
                </div>
                <div class="form-group col-md-3 ">
                    <label class="col-form-label">Country</label>
                    <input type="text" id="category" readonly value="{{selectedCountry}}" class="form-control">
                </div>
                <div class="form-group col-md-3 ">
                  <label class="col-form-label">Max Amount</label>
                  <div class="d-flex">
                    <input type="text" maxlength="6" [readonly]="maxBalanceField" [(ngModel)]="maxBalance" id="maxBalance" name="maxBalance" autocomplete="off"  class="form-control" placeholder="Max Amount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                    <button type="button" class="btn btn-primary" *ngIf="!permissions.includes('Approve')"  (click)="editMaxAmount()"><i class="feather icon-edit"></i></button>
                  </div>
                </div>
            </div>
            <hr>
            <div class="row d-flex">
                <div class="text-right">
                  <button type="button" class="btn btn-primary"   (click)="cloneSavedData()"  *ngIf="permissions.includes('Edit') && showSavedDataTable">Copy</button>
                    <button type="button" class="btn btn-primary"  (click)="addSlab()" *ngIf="permissions.includes('Edit')">Add Slab</button>
                    <button type="button" class="btn btn-primary" (click)="reviewSlab($event)" *ngIf="permissions.includes('Approve')">Review</button>
                </div>
            </div>
            <div class="row d-flex" *ngIf="!showSavedDataTable">
              <h4 style="color: red;">Rates are not yet configured for this country</h4>
          </div>
            <div class="row d-flex mt-2" *ngIf="showSavedDataTable">
                    <div class="form-group col-md-12 " >
                        <div class="row mb-0" style="min-height: 270px" >
                            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                              <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
                                [columnDefs]="tableSelectedColumnSaved" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                                 [rowData]="savedSlabData" [rowSelection]="'single'"
                                [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                              </ag-grid-angular>
                            </div>
                          </div>
                    </div>
            </div>
            <div class="row d-flex">
                <div class="form-group col-md-3 " *ngIf="showType">
                    <label class="col-form-label" for="type">Type<span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <ng-select  id="type" (change)="typeSelect($event)"  placeholder="Select Type" required name="type">
                        <ng-option value="DIRECT">Direct</ng-option>
                        <ng-option value="SLAB">Slab</ng-option>
                      </ng-select>
                </div>
                <div class="row d-flex" *ngIf="selectedDirect">
                    <div class="form-group col-md-12 "  >
                        <div class="d-flex justify-content-between">
                            <h5 class="text-left">Direct</h5>
                            <div class="text-right">
                                <button type="button" class="btn btn-primary" (click)="clearTable('DIRECT')">Clear</button>
                            </div>
                        </div>
                        <div class="row mb-0" style="min-height: 270px">
                            <div class=" grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                              <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReadySlab($event)" 
                                [columnDefs]="tableSelectedColumnDirect" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                                 [rowData]="directData" [rowSelection]="'single'"
                                [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                              </ag-grid-angular>
                            </div>
                          </div>
                    </div>
                </div>
                <div class="row d-flex"  *ngIf="selectedSlab">
                    <div class="form-group col-md-12 ">
                        <div class="d-flex mb-2 justify-content-between">
                            <h5 class="text-left">Slab</h5>
                            <div class="text-right">
                                <button type="button" class="btn btn-primary" (click)="addRow()">Add</button>
                                <button type="button" class="btn btn-primary" (click)="clearTable('SLAB')">Clear</button>
                            </div>
                        </div>
                        <div class="row mb-0" style="min-height: 270px">
                            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                              <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReadySlab($event)"
                                [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true  
                                 [rowData]="slabData" [rowSelection]="'single'"
                                [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                              </ag-grid-angular>
                            </div>
                          </div>
                    </div>
                </div>
            </div>
            <br>
              <div class="row d-flex">
                  <div class="form-group col-md-12 text-right">
                      <button type="submit" class="btn btn-primary" *ngIf="saveButtonVisible" (click)="addExchangeSlabs()">Save</button>
                      <button type="button" class="btn btn-danger" id="cancelButton" (click)="cancelButton()" >Cancel</button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>


    <app-modal #openReviewSlab [modalConfig]="modalExchangeReview" style="width: 1200px;">
   
        <h4 class="text-center">Review Changes</h4>
        <div *ngIf="showOldSlab">
        <br>
        <br>
        <h5>Old Slab</h5>
        <div class="row d-flex">
            <div class="form-group col-md-12 " >
                <div class="row mb-0" style="min-height: 270px">
                    <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                      <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
                        [columnDefs]="tableSelectedColumnSaved" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                         [rowData]="oldSlabs" [rowModelType]="" [rowSelection]="'single'"
                        [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                      </ag-grid-angular>
                    </div>
                  </div>
            </div>
        </div>
        </div>
        <div *ngIf="showNewSlab">
        <br>
        <br>
        <h5>New Slab</h5>
        <div class="row d-flex">
            <div class="form-group col-md-12 " >
                <div class="row mb-0" style="min-height: 270px">
                    <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                      <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"  
                        [columnDefs]="tableSelectedColumnSaved" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                         [rowData]="newSlabs" [rowModelType]="" [rowSelection]="'single'"
                        [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                      </ag-grid-angular>
                    </div>
                  </div>
            </div>
        </div>
        </div>
        
        <div class="row d-flex">
            <div class="form-group col-md-12">
                <div class="text-center">
                <input type="text" autocomplete="off" id="inputBorder" placeholder="Enter the Remarks"  [(ngModel)]="slabRemarks" >
                </div>
            </div>
        </div>
        
        
        <div class="row d-flex">
            <div class="form-group col-md-12 text-center">
                <button type="button" class="btn btn-primary" (click)="statusChangeForSlab('ACTIVE')">Approved</button>
                <button type="button" class="btn btn-secondary" id="cancelButton"(click)="statusChangeForSlab('REJECTED')" >Reject</button>
            </div>
        </div>
        
        </app-modal> 